import React, { useEffect, useState } from "react";

type ReviewsSliderProps = {
  langFile?: string;
  data: {
    length: number;
    type: string;
    heading: string;
    testimonials: {
      avatar: string;
      name: string;
      title: string;
      website: string;
      websiteText?: string;
      text: string;
    }[];
  };
};

const ReviewsSlider: React.FC<ReviewsSliderProps> = ({ data, langFile }) => {
  const [review, setReview] = useState(0);
  const increment = () => setReview((i) => i + 1);

  useEffect(() => {
    const id = setInterval(increment, 3000);
    return () => clearInterval(id);
  }, []);

  const currImageIndex = review % data?.testimonials.length;

  const currTestimonial = data?.testimonials[currImageIndex];
  // const Translate = useTranslator(langFile);

  return (
    <div className="mb-12 w-full md:container">
      <h2 className="container mb-10 text-center text-title-32 text-black">
        {data?.heading}
      </h2>
      <div className="text-gray-200 flex flex-col items-center justify-start gap-6 self-stretch">
        <div className="box-border flex flex-row items-center justify-start gap-[48px] self-stretch overflow-hidden bg-purple-0 px-4 py-6 text-left text-5xl text-grey-4  md:max-w-[960px] md:rounded-3xl md:p-6">
          <>
            <img
              className="object-fit relative hidden max-h-full shrink-0 self-stretch overflow-hidden rounded-xl md:block"
              alt=""
              src={currTestimonial.avatar}
              height={230}
              width={230}
            />
          </>

          <div className="flex flex-col gap-5">
            <div className="text-body-16 text-grey-4 md:text-body-24">
              {currTestimonial.text}
            </div>
            <div className="flex gap-2 md:hidden">
              <img
                className="object-fit relative max-h-full shrink-0 self-stretch overflow-hidden rounded-xl"
                alt=""
                src={currTestimonial.avatar}
                height={64}
                width={64}
              />
              <div className="flex flex-col gap-1">
                <div className="text-title-16 text-grey-4">
                  {currTestimonial.name}
                </div>
                <div className="text-title-14 text-grey-3">
                  {currTestimonial.title}
                </div>
                <div className="flex gap-1.5 text-title-12 text-purple-4">
                <a href={currTestimonial.website} target="_blank">
                    {currTestimonial.website}
                  </a>
                  <img src="/images/LinkUp.svg" />
                </div>
              </div>
            </div>
            <div className="flex hidden flex-col md:block">
              <div className="text-title-24 text-grey-4">
                {currTestimonial.name}
              </div>
              <div className="flex justify-between">
                <div className="text-title-16 text-grey-3">
                  {currTestimonial.title}
                </div>
                <div className="flex gap-1.5 text-body-16 text-purple-4">
                  <a href={currTestimonial.website} target="_blank">
                    {currTestimonial.website}
                  </a>

                  <img src="/images/LinkUp.svg" />
                </div>
              </div>
            </div>
            <div className="flex flex-row items-start justify-start gap-[8px] self-stretch">
              {data?.testimonials.map((reviewItem, index) => {
                return (
                  <div
                    key={reviewItem.title}
                    className={`relative h-[5px] flex-1 rounded-xl ${
                      index === currImageIndex ? "bg-purple-3" : "bg-grey-0"
                    }`}
                  />
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ReviewsSlider;
